export default __webpack_public_path__ + "static/media/monkey_dark_male.abbec045.png";